import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="podcasts" />;

export const Route = createFileRoute("/en/podcasts/$slug")({
  loader: ({ params }) => loadContentMeta("podcasts", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/podcasts/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

